import { router } from "..";
import { getFarmcamSim } from "../api/farmcam-sims_{imsi}";
import { getPrices } from "../api/prices";
import { deviceCard, formatSubscriptionStatus } from "../device/device_card";
import { locale } from "../locale";
import { addNotificationListener } from "../mobile";
import { state } from "../state";
import { formatDataAmount } from "../utils";
import { keyValueParagraph } from "../view/components";
import { Html } from "../view/html";
import { MaterialDesign } from "../view/material_design";
import { getFarmcamSimWarnings } from "./fcs_warnings";

/**
 * @param {FarmcamSim} fcs
 */
async function farmcamSimCard(fcs) {
	addNotificationListener("farmcamsim", fcs.Imsi, () => {
		getFarmcamSim(fcs.Imsi).then((fcs) => {
			state.farmcamSims[fcs.Imsi] = fcs;
			// refresh(fcs)
		});
	});

	return deviceCard({
		deviceName: fcs.Metadata.Name,
		deviceType: "farmcam-sim",
		productName: "FarmCam SIM",
		warnings: getFarmcamSimWarnings(fcs),
		lines: [
			keyValueParagraph(
				locale.string({
					enGB: "Remaining data",
					deDE: "Verbleibende Daten",
					frFR: "Données restantes",
					svSE: "Återstående data",
				}),
				formatDataAmount(fcs.RemainingData),
			),
			keyValueParagraph(
				locale.string({
					enGB: "Subscription",
					deDE: "Abonnement",
					frFR: "Abonnement",
					svSE: "Prenumeration",
				}),
			),
			keyValueParagraph(
				locale.string({
					enGB: "- Plan",
					deDE: "- Plan",
					frFR: "- Plan",
					svSE: "- Plan",
				}),
				await formatSubscriptionPlan(fcs),
			),
			keyValueParagraph(...formatSubscriptionStatus(fcs.Subscription)),
		],
		buttons: [
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "monitoring",
					onClick: () => router.jump(`/farmcam-sim/${fcs.Imsi}/logs`),
				}),
			),
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "settings",
					onClick: () => router.jump(`/farmcam-sim/${fcs.Imsi}`),
				}),
			),
		],
	});
}

/**
 * @param {FarmcamSim} fcs
 */
async function formatSubscriptionPlan(fcs) {
	if (fcs.Subscription.Trialing) return locale.strings.trial;

	const { FarmcamSimLarge, FarmcamSimMedium, FarmcamSimSmall } =
		await getPrices();

	/** @type {(price: import('../billing/prices').Price) => string} */
	const formatPrice = (price) => {
		const matches = price.Name.match(/([0-9]+ [KMGT]?B)/gm);
		if (!matches) throw `invalid subscription name for price: ${price.Id}`;
		return matches[0];
	};

	switch (fcs.Subscription.PriceIds.Current) {
		case FarmcamSimLarge.Id:
			return formatPrice(FarmcamSimLarge);
		case FarmcamSimMedium.Id:
			return formatPrice(FarmcamSimMedium);
		case FarmcamSimSmall.Id:
			return formatPrice(FarmcamSimSmall);
	}

	// This is to handle the transition period from priceId to priceIds.current/next
	const expiryTime = new Date(fcs.Subscription.ExpiresAt);
	if (Date.now() < expiryTime.getTime()) return "";

	return locale.strings.none;
}

export { farmcamSimCard };
